import { render } from "./FieldsetComponent.vue?vue&type=template&id=a272eb06&scoped=true"
import script from "./FieldsetComponent.vue?vue&type=script&lang=js"
export * from "./FieldsetComponent.vue?vue&type=script&lang=js"

import "./FieldsetComponent.vue?vue&type=style&index=0&id=a272eb06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a272eb06"]])

export default __exports__